export default __webpack_public_path__ + "static/media/screen-alura.285e9415.png";